import { ReactNode } from "react";
import { usePermission } from "@/hooks/usePermission";

type PermissionGateProps = {
  permission?: string;
  anyOf?: string[];
  allOf?: string[];
  children: ReactNode;
  fallback?: ReactNode;
};

const PermissionGate = ({
  permission,
  anyOf,
  allOf,
  children,
  fallback = null,
}: PermissionGateProps) => {
  const { hasPermission, hasAnyPermission, hasAllPermissions } =
    usePermission();

  const singleCheck = permission ? hasPermission(permission) : true;
  const anyCheck = anyOf?.length ? hasAnyPermission(anyOf) : true;
  const allCheck = allOf?.length ? hasAllPermissions(allOf) : true;

  if (!singleCheck || !anyCheck || !allCheck) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default PermissionGate;
